var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAfishaDaily = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#8E00FF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.649
}, /*#__PURE__*/React.createElement("path", {
  d: "m34.53 22.027 2.556-10.996L26.09 22.027l8.114-4.22M49.554 11.031 38.559 22.027M56.724 11.031 45.73 22.027l7.403-1.442M47.447 27.675 78.5 11.92M69.184 11.031 58.018 22.197M15.792 8.098 5.5 22.554S31.027 17.6 31.027 7.814c0-3.131-2.902-4.322-7.135-4.322C15.124 3.492 6.9 9.256 6.9 9.256"
}))));
export default SvgIconAfishaDaily;